import React from 'react';
import Accordion from 'components/Accordion';
import Button from 'components/DesignSystem/Button';
import useSoil from 'hooks/Meteorology/Agro/WaterBalanceSequential/DetailedView/useSoil';

export default function Soil() {
  const {
    selectedSoil,
    soilTypes,
    onSoilClick,
  } = useSoil();

  return (
    <Accordion.Item eventKey="soil" id="soil-accordion">
      <Accordion.Header>Tipo de Solo</Accordion.Header>
      <Accordion.Body>
        { soilTypes.map((soil) => (
          <Button
            key={soil.id}
            className={`w-100 btn-control-panel ${selectedSoil === soil.id ? 'btn-control-panel-active' : ''}`}
            type="tertiary"
            onClick={onSoilClick(soil.id)}
          >
            {soil.label}
          </Button>
        ))}
      </Accordion.Body>
    </Accordion.Item>
  );
}
